import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import PaymentCalculator from "@/pages/PaymentCalculator";

export const Route = createFileRoute("/payment-calculator")({
  head: () => pageHead({
    title: 'RV Payment Calculator',
    description: 'Estimate your monthly RV payment with the Rex & Sons RVs calculator — adjust price, down payment, term and rate to fit your budget.',
    path: '/payment-calculator',
  }),
  component: PaymentCalculator,
});
